/**
 * @typedef {import('./get-force-upgrade-status').ForceUpgradeBillingData} ForceUpgradeBillingData
 * @typedef {import('./get-force-upgrade-status').ForceUpgradeStatus} ForceUpgradeStatus
 */

export const FORCE_UPGRADE_STATUS = {
    NONE: 'none',
    LAPSED_TRIAL_OWNER: 'lapsed-trial-owner',
    INCOMPLETE_OWNER: 'incomplete-owner',
    NON_OWNER: 'non-owner',
    STALE_OWNER: 'stale-owner',
};

/**
 * Resolves Ghost's Force upgrade role together with Billing's authoritative
 * subscription state.
 * @param {ForceUpgradeBillingData|null|undefined} billingData
 * @returns {ForceUpgradeStatus}
 */
export default function getForceUpgradeStatus(billingData) {
    if (billingData?.isForceUpgrade !== true) {
        return FORCE_UPGRADE_STATUS.NONE;
    }

    if (billingData?.forceUpgradeNoOwner) {
        return FORCE_UPGRADE_STATUS.NON_OWNER;
    }

    if (!billingData?.forceUpgradeOwner) {
        return FORCE_UPGRADE_STATUS.NONE;
    }

    if (billingData?.subscription?.status === 'active') {
        return FORCE_UPGRADE_STATUS.STALE_OWNER;
    }

    if (billingData?.subscription?.status === 'incomplete' || billingData?.isIncomplete) {
        return FORCE_UPGRADE_STATUS.INCOMPLETE_OWNER;
    }

    return FORCE_UPGRADE_STATUS.LAPSED_TRIAL_OWNER;
}
